export default "__VITE_ASSET__FGW0HEtk__"